import { Component, Input } from '@angular/core';
import { Amenity } from '../../models/amenity.model';
import { NgbActiveModal, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { ScheduleService } from '../../services/schedule.service';
import { UtilService } from '../../services/util.service';
import { Timetable } from '../../models/timetable.model';
import { StreetBuildingService } from '../../services/street-building.service';
import { HouseFlatService } from '../../services/house-flat.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StreetBuilding } from '../../models/street-building.model';
import { HouseFlat } from '../../models/house-flat.model';
import moment from 'moment';
import { BookingService } from '../../services/booking.service';

@Component({
  selector: 'app-create-booking-modal',
  templateUrl: './create-booking-modal.component.html',
  styleUrl: './create-booking-modal.component.scss'
})
export class CreateBookingModalComponent {

  @Input() neighborhoodId: string = '';
  @Input() amenity?: Amenity;

  public housesFlats: HouseFlat[] = [];
  public timetables: Timetable[] = [];

  public formBooking: FormGroup;

  public submitted: boolean = false;
  public loadingSchedules: boolean = false;
  private dateSelected: string = '';

  public timetableSelected?: Timetable;
  
  constructor(
    public activeModal: NgbActiveModal,
    private bookingService: BookingService,
    private formBuilder: FormBuilder,
    public houseFlatService: HouseFlatService,
    private scheduleService: ScheduleService,
    public streetBuildingService: StreetBuildingService,
    public utilService: UtilService
  ) {

    this.formBooking = this.formBuilder.group({
      streetBuildingId: [null, Validators.required],
      houseFlatId: [null, Validators.required],
      dateSelected: ['', Validators.required],
      timetableId: [null, Validators.required],
      guests: [0],
      isBlocked: [false],
    })

  }

  ngOnInit(): void {

    this.streetBuildingService.getAll(
      this.neighborhoodId
    );

  }

  get f() {
    return this.formBooking.controls;
  } 

  /*
   ██████╗ ███╗   ██╗ ██████╗██╗  ██╗ █████╗ ███╗   ██╗ ██████╗ ███████╗███████╗████████╗██████╗ ███████╗███████╗████████╗██████╗ ██╗   ██╗██╗██╗     ██████╗ ██╗███╗   ██╗ ██████╗
  ██╔═══██╗████╗  ██║██╔════╝██║  ██║██╔══██╗████╗  ██║██╔════╝ ██╔════╝██╔════╝╚══██╔══╝██╔══██╗██╔════╝██╔════╝╚══██╔══╝██╔══██╗██║   ██║██║██║     ██╔══██╗██║████╗  ██║██╔════╝
  ██║   ██║██╔██╗ ██║██║     ███████║███████║██╔██╗ ██║██║  ███╗█████╗  ███████╗   ██║   ██████╔╝█████╗  █████╗     ██║   ██████╔╝██║   ██║██║██║     ██║  ██║██║██╔██╗ ██║██║  ███╗
  ██║   ██║██║╚██╗██║██║     ██╔══██║██╔══██║██║╚██╗██║██║   ██║██╔══╝  ╚════██║   ██║   ██╔══██╗██╔══╝  ██╔══╝     ██║   ██╔══██╗██║   ██║██║██║     ██║  ██║██║██║╚██╗██║██║   ██║
  ╚██████╔╝██║ ╚████║╚██████╗██║  ██║██║  ██║██║ ╚████║╚██████╔╝███████╗███████║   ██║   ██║  ██║███████╗███████╗   ██║   ██████╔╝╚██████╔╝██║███████╗██████╔╝██║██║ ╚████║╚██████╔╝
   ╚═════╝ ╚═╝  ╚═══╝ ╚═════╝╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═══╝ ╚═════╝ ╚══════╝╚══════╝   ╚═╝   ╚═╝  ╚═╝╚══════╝╚══════╝   ╚═╝   ╚═════╝  ╚═════╝ ╚═╝╚══════╝╚═════╝ ╚═╝╚═╝  ╚═══╝ ╚═════╝

  */
  onChangeStreetBuilding(streetBuilding?: StreetBuilding) {

    console.log('StreetBuilding', streetBuilding);

    if(streetBuilding) {

      this.housesFlats = streetBuilding.housesFlats;

    } else {
      this.housesFlats = [];
    }

  }

  /*
   ██████╗ ███╗   ██╗ ██████╗██╗  ██╗ █████╗ ███╗   ██╗ ██████╗ ███████╗████████╗██╗███╗   ███╗███████╗████████╗ █████╗ ██████╗ ██╗     ███████╗
  ██╔═══██╗████╗  ██║██╔════╝██║  ██║██╔══██╗████╗  ██║██╔════╝ ██╔════╝╚══██╔══╝██║████╗ ████║██╔════╝╚══██╔══╝██╔══██╗██╔══██╗██║     ██╔════╝
  ██║   ██║██╔██╗ ██║██║     ███████║███████║██╔██╗ ██║██║  ███╗█████╗     ██║   ██║██╔████╔██║█████╗     ██║   ███████║██████╔╝██║     █████╗
  ██║   ██║██║╚██╗██║██║     ██╔══██║██╔══██║██║╚██╗██║██║   ██║██╔══╝     ██║   ██║██║╚██╔╝██║██╔══╝     ██║   ██╔══██║██╔══██╗██║     ██╔══╝
  ╚██████╔╝██║ ╚████║╚██████╗██║  ██║██║  ██║██║ ╚████║╚██████╔╝███████╗   ██║   ██║██║ ╚═╝ ██║███████╗   ██║   ██║  ██║██████╔╝███████╗███████╗
   ╚═════╝ ╚═╝  ╚═══╝ ╚═════╝╚═╝  ╚═╝╚═╝  ╚═╝╚═╝  ╚═══╝ ╚═════╝ ╚══════╝   ╚═╝   ╚═╝╚═╝     ╚═╝╚══════╝   ╚═╝   ╚═╝  ╚═╝╚═════╝ ╚══════╝╚══════╝

  */
  onChangeTimetable(timetable?: Timetable) {
    console.log('Timetable', timetable);

    this.timetableSelected = timetable;
  }

  /*
   ██████╗ ███╗   ██╗██████╗  █████╗ ████████╗███████╗███████╗███████╗██╗     ███████╗ ██████╗████████╗██╗ ██████╗ ███╗   ██╗
  ██╔═══██╗████╗  ██║██╔══██╗██╔══██╗╚══██╔══╝██╔════╝██╔════╝██╔════╝██║     ██╔════╝██╔════╝╚══██╔══╝██║██╔═══██╗████╗  ██║
  ██║   ██║██╔██╗ ██║██║  ██║███████║   ██║   █████╗  ███████╗█████╗  ██║     █████╗  ██║        ██║   ██║██║   ██║██╔██╗ ██║
  ██║   ██║██║╚██╗██║██║  ██║██╔══██║   ██║   ██╔══╝  ╚════██║██╔══╝  ██║     ██╔══╝  ██║        ██║   ██║██║   ██║██║╚██╗██║
  ╚██████╔╝██║ ╚████║██████╔╝██║  ██║   ██║   ███████╗███████║███████╗███████╗███████╗╚██████╗   ██║   ██║╚██████╔╝██║ ╚████║
   ╚═════╝ ╚═╝  ╚═══╝╚═════╝ ╚═╝  ╚═╝   ╚═╝   ╚══════╝╚══════╝╚══════╝╚══════╝╚══════╝ ╚═════╝   ╚═╝   ╚═╝ ╚═════╝ ╚═╝  ╚═══╝

  */
  async onDateSelection(event: NgbDate) {

    console.log('event', event);

    this.dateSelected = moment(
      event.year + '-' + event.month + '-' + event.day
    ).format('YYYY-MM-DD');

    // console.log('dateSelected', this.dateSelected);

    this.loadingSchedules = true;
    
    this.timetables = await this.scheduleService.getAll(
      this.amenity!,
      this.dateSelected
    );
    
    this.timetableSelected = undefined;

    this.formBooking.patchValue({
      isBlocked: false,
      timetableId: null,
    });

    this.loadingSchedules = false;
  }

  /*
   ██████╗ ███╗   ██╗███████╗██╗   ██╗██████╗ ███╗   ███╗██╗████████╗
  ██╔═══██╗████╗  ██║██╔════╝██║   ██║██╔══██╗████╗ ████║██║╚══██╔══╝
  ██║   ██║██╔██╗ ██║███████╗██║   ██║██████╔╝██╔████╔██║██║   ██║
  ██║   ██║██║╚██╗██║╚════██║██║   ██║██╔══██╗██║╚██╔╝██║██║   ██║
  ╚██████╔╝██║ ╚████║███████║╚██████╔╝██████╔╝██║ ╚═╝ ██║██║   ██║
   ╚═════╝ ╚═╝  ╚═══╝╚══════╝ ╚═════╝ ╚═════╝ ╚═╝     ╚═╝╚═╝   ╚═╝

  */
  async onSubmit() {

    this.submitted = true;

    console.log('Form', this.formBooking);

    // return;

    if(this.formBooking.invalid) {
      return;
    }

    console.log('Ya pasa');

    this.formBooking.patchValue({
      dateSelected: this.dateSelected,
    });

    const flag = await  this.bookingService.create(
      this.amenity!,
      this.formBooking.value
    );

    if(flag) {
      this.activeModal.close();
    }
    

  }

}
